// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1IzN6","header":"ReportDetails_header__1xFpK","title":"ReportDetails_title__12nmb","left":"ReportDetails_left__2y27v"};